module.exports = __webpack_public_path__ + "static/atakule-7f1ab320b0bc583872852611b937ea25.jpg";